import React, { Dispatch } from 'react';
import { useDispatch } from 'react-redux';
import { Action } from 'typesafe-actions';
import { loadRequest } from '../../../../../../store/ducks/coletaNoCd/actions';
import { Card, Checkbox, List } from 'antd';
import { RowLine, SpanBlock } from './styles';
import { maskCurrency, maskUnd } from '../../../../../../utils/mask';
import ModalItensNota from '../Modal';

interface DataType {
  key: React.Key;
  nome: string;
  peso: number;
  valor: number;
}

const CardMobile: React.FC<any> = ({
  props,
  loading,
  inscricaoAtiva,
  cddAtivo,
  filter,
  pagination,
  setAddweight,
  setAmount,
  setaArraySelectedItens,
}) => {
  const dispatch = useDispatch<Dispatch<Action>>();

  const onChange = (selectedRows: DataType[]) => {
    const resArr: any = [];
    const resArrAmount: any = [];

    selectedRows.map((itemMovi) => resArr.push(+itemMovi.peso));
    setAddweight(resArr.reduce((a: any, b: any) => a + b, 0).toFixed(2));
    selectedRows.map((itemMovi) => resArrAmount.push(+itemMovi.valor));
    setAmount(resArrAmount.reduce((a: any, b: any) => a + b, 0).toFixed(2));
    setaArraySelectedItens(selectedRows);
  };

  const paginationProps = {
    onChange: (pag: any) => {
      const resultado = {
        ...pagination,
        current: pag,
      };
      dispatch(
        loadRequest(
          filter,
          filter?.codParceiro ? [+filter.codParceiro] : inscricaoAtiva,
          cddAtivo?.codEmp,
          resultado
        )
      );
    },
    showSizeChanger: true,
    current: pagination.current,
    pageSize: pagination.pageSize,
    total: pagination.total,
  };

  return (
    <Checkbox.Group style={{ width: '100%' }} onChange={(e: any) => onChange(e)}>
      <List
        grid={{ gutter: 16, column: 1 }}
        pagination={paginationProps}
        loading={loading}
        dataSource={props}
        renderItem={(item: any) => (
          <List.Item>
            <Card title={props.nuNota}>
              <Checkbox value={item} />
              <RowLine>
                <p>
                  <strong>Nota fiscal</strong>
                  <SpanBlock>
                    {item.nuNotaEmitida ? (
                      <>{<ModalItensNota nuNota={item.nuNotaEmitida} numNF={100} />}</>
                    ) : (
                      'Nota não emitida'
                    )}
                  </SpanBlock>
                </p>
                <p>
                  <strong>Cliente</strong> <SpanBlock>{item.parceiro}</SpanBlock>
                </p>
                <p>
                  <strong>Transportadora</strong> <SpanBlock>{item.transportadora}</SpanBlock>
                </p>
              </RowLine>
              <RowLine>
                <p>
                  <strong>Destino</strong>{' '}
                  <SpanBlock>{item.cidadeDestino + '-' + item.siglaUf}</SpanBlock>
                </p>
              </RowLine>
              <RowLine>
                <p>
                  <strong>Peso bruto</strong> <SpanBlock>{maskUnd(item.peso) + ' KG'}</SpanBlock>
                </p>
                <p>
                  <strong>Valor da mercadoria</strong>{' '}
                  <SpanBlock>{maskCurrency(item.valor)}</SpanBlock>
                </p>
              </RowLine>
            </Card>
          </List.Item>
        )}
      />
    </Checkbox.Group>
  );
};
export default CardMobile;
